import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		// Page subtitle below the header
		pageSubtitle: {
			color: theme.palette.custom.textSecondary,
			marginBottom: 32,
		},
		// Section heading (top of each card)
		sectionHeading: {
			fontWeight: "bold",
			fontSize: 18,
			color: theme.palette.custom.textPrimary,
			marginBottom: 4,
		},
		// Bold title for a control row (checkbox/toggle)
		labelTitle: {
			fontWeight: "bold",
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
		},
		// Description text under a control label
		labelDescription: {
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
			marginTop: 4,
		},
		// Dialog body text
		dialogText: {
			color: theme.palette.custom.textPrimary,
		},
	} satisfies Record<string, CSSObject>);
};
